import { makeRoute } from '~/utils/route';

export default makeRoute({
	path:        '/e-sign/:id',
	title:       'menu.e-sign',
	redirectTo:  routeParameters => {
		return `/front5/e-sign/${routeParameters?.id}`
	},
});
